import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import config from "../config/env";

import { useSessionContext } from "../contexts/session-context";
import { SESSION_NAME } from "../constants/session";

export default function Login() {
  const [username, setUsername] = useState("");
  const [pwd, setPwd] = useState("");
  const [remember, setRemember] = useState(false);

  const [loading, setLoading] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [okMsg, setOkMsg] = useState("");

  const [, setSession] = useSessionContext();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/app";
  const nav = useNavigate();

  const fetchProfileWithRole = async (jwt) => {
    const profileRes = await axios.get(`${config.api || ""}/auth/profile`, {
      headers: {
        "X-API-KEY": "stock-management-X-api-key",
        Authorization: `Bearer ${jwt}`,
      },
      withCredentials: false,
    });

    const profileUser = profileRes?.data?.user || profileRes?.data || null;
    const roleName = String(profileUser?.role?.name || "").trim();
    return { profileUser, roleName };
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrMsg("");
    setOkMsg("");

    try {
      const res = await axios.post(
        `${config.api || ""}/auth/local`,
        { identifier: username, password: pwd },
        {
          headers: { "X-API-KEY": "stock-management-X-api-key" },
          withCredentials: false,
        }
      );

      console.log("res", res)

      const jwt = res?.data?.jwt;
      const user = res?.data?.user;
      if (!jwt) throw new Error("ไม่พบ jwt ในผลลัพธ์");

      const { profileUser, roleName } = await fetchProfileWithRole(jwt);
      const nextUser = profileUser || user;

      localStorage.setItem("jwt", jwt);
      localStorage.setItem("auth_user", JSON.stringify(nextUser));
      localStorage.setItem("auth_role_name", roleName || "");
      Cookies.set(SESSION_NAME, jwt, {
        path: "/",
        sameSite: "Lax",
        secure: window.location.protocol === "https:",
        ...(remember ? { expires: 7 } : {}),
      });

      setSession({ isAuthenticated: true, user: nextUser, roleName, loading: false });
      nav(from, { replace: true });
    } catch (err) {
      console.error("login error:", err);
      const status = err?.response?.status;
      if (status === 400 || status === 401) setErrMsg("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง");
      else setErrMsg("ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่");
    } finally {
      setLoading(false);
    }
  };

  // ✅ REGISTER (Hardcode payload ตามที่คุณให้มา)
  const onRegister = async () => {
    setRegisterLoading(true);
    setErrMsg("");
    setOkMsg("");

    try {
      const payload = {
        username: "test",
        email: "test@test.com",
        password: "test1234",
      };

      const res = await axios.post(
        `${config.api || ""}/auth/local/register`,
        payload,
        {
          headers: { "X-API-KEY": "stock-management-X-api-key" },
          withCredentials: false,
        }
      );

      // Strapi จะคืน jwt + user เหมือน login
      const jwt = res?.data?.jwt;
      const user = res?.data?.user;

      setOkMsg("สมัครสมาชิกสำเร็จ (test@test.com / test1234)");
      // ถ้าอยากให้สมัครแล้ว login อัตโนมัติด้วย ให้เปิดบล็อกนี้:
      if (jwt) {
        const { profileUser, roleName } = await fetchProfileWithRole(jwt);
        const nextUser = profileUser || user;

        localStorage.setItem("jwt", jwt);
        localStorage.setItem("auth_user", JSON.stringify(nextUser));
        localStorage.setItem("auth_role_name", roleName || "");
        Cookies.set(SESSION_NAME, jwt, {
          path: "/",
          sameSite: "Lax",
          secure: window.location.protocol === "https:",
          ...(remember ? { expires: 7 } : {}),
        });
        setSession({ isAuthenticated: true, user: nextUser, roleName, loading: false });
        nav(from, { replace: true });
      }
    } catch (err) {
      console.error("register error:", err);
      // Strapi มักตอบ 400 ถ้า email/username ซ้ำ
      const msg =
        err?.response?.data?.error?.message ||
        err?.response?.data?.message ||
        "สมัครสมาชิกไม่สำเร็จ (อาจมี email/username ซ้ำ)";
      setErrMsg(msg);
    } finally {
      setRegisterLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-[#f3f4f6] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl px-10 py-14">
        <div className="text-left flex flex-col w-10/12 mx-auto">
          <div className="text-sm font-semibold text-[#047DED]">Backoffice - BestPhone</div>
          <h1 className="mt-2 text-4xl font-semibold text-[#111827]">ยินดีต้อนรับ!</h1>
          <p className="mt-3 text-sm text-[#1D1616B2]">เข้าสู่ระบบเพื่อจัดการข้อมูลสต๊อกสินค้า</p>
          <div className="mt-4 h-[3px] w-full bg-[#047DED]" />
        </div>

        <form onSubmit={onSubmit} className="mt-7 flex flex-col items-center">
          <div className="w-10/12 space-y-4">
            <input
              type="text"
              placeholder="Username"
              className="w-full h-12 rounded-md border border-[#e5e7eb] bg-white px-4 text-sm outline-none shadow-sm focus:border-[#3b82f6] focus:ring-2 focus:ring-[#3b82f6]/20 placeholder:text-[#22283180]"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />

            <input
              type="password"
              placeholder="Password"
              className="w-full h-12 rounded-md border border-[#e5e7eb] bg-white px-4 text-sm outline-none shadow-sm focus:border-[#3b82f6] focus:ring-2 focus:ring-[#3b82f6]/20 placeholder:text-[#22283180]"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              required
              autoComplete="current-password"
            />

            {/* <label className="flex items-center gap-2 text-sm text-[#1D1616B2]">
              <input
                type="checkbox"
                className="h-4 w-4 rounded border-[#d1d5db]"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              จดจำฉัน
            </label> */}

            {errMsg && <div className="text-sm text-rose-600">{errMsg}</div>}
            {okMsg && <div className="text-sm text-emerald-600">{okMsg}</div>}

            <button
              type="submit"
              disabled={loading || registerLoading}
              className="w-full h-12 rounded-md bg-[#047DED] text-white font-semibold shadow-lg shadow-[#047DED66]/30 hover:bg-[#0a6ac2] disabled:opacity-60 transition"
            >
              {loading ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}
            </button>
            <div className="text-sm text-[#1D1616B2] text-center">
              เวอร์ชั่น 1.0.7
            </div>

            {/* ✅ ปุ่ม Register (Hardcode payload) */}
            {/* <button
              type="button"
              onClick={onRegister}
              disabled={registerLoading || loading}
              className="w-full h-12 rounded-md border border-[#047DED] text-[#047DED] font-semibold hover:bg-[#047DED]/10 disabled:opacity-60 transition"
            >
              {registerLoading ? "กำลังสมัครสมาชิก..." : "สมัครสมาชิก (Hardcode)"}
            </button> */}
          </div>
        </form>
      </div>
    </div>
  );
}
